import { REGIONS } from "@/lib/regions";

export function RegionNav({ counts, value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="region-nav">
      {REGIONS.map((r) => {
        const active = value === r.id;
        return (
          <button
            key={r.id}
            onClick={() => onChange(r.id)}
            className={`inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm transition-colors duration-150 ${
              active
                ? "bg-neon text-white border-neon font-medium shadow-sm"
                : "border-line bg-panel text-foreground hover:border-neon hover:text-neon"
            }`}
            data-testid={`region-${r.id}`}
          >
            <span>{r.label}</span>
            <span
              className={`font-mono text-xs ${active ? "text-white/80" : "text-dim"}`}
            >
              {counts[r.id] || 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function ChipRow({ chips, value, onChange }) {
  if (!chips.length) {
    return (
      <p className="text-xs text-dim font-mono py-1">
        no IPs for this region yet · click Scan
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="chip-row">
      {chips.map((c) => {
        const active = value === c.code;
        return (
          <button
            key={c.code}
            onClick={() => onChange(active ? null : c.code)}
            className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 font-mono text-xs transition-colors duration-150 ${
              active
                ? "border-neon bg-accent text-neon"
                : "border-line bg-black text-dim hover:text-foreground hover:border-dim"
            }`}
            data-testid={`chip-${c.code}`}
          >
            <span className="font-semibold">{c.code}</span>
            <span className="opacity-70">{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
